// extracted by mini-css-extract-plugin
export default {"submitButton":"SocialLinkSubmit_submitButton__l5ZZT"};